import * as React from "react";
import _ from 'lodash';

let componentId = 0;
let globalSpinner;
const components = [];

const styles = {
  text: {
    display:"block",
    fontSize:10,
    marginTop: 200,
    color: "#888",
    marginLeft: 6,
  },
  container: {
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    zIndex: 1000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexFlow: "column nowrap",
  }
};

class Loader extends React.Component{
    constructor(props){
      super();
      this.state = {
        id:componentId++,
      }
    }
    componentDidMount(){
      components.push({
        id:this.state.id,
        text:this.props.text,
      })

    }
    componentWillUnmount(){
      _.remove(components,{id:this.state.id});
    }

    render(){
      const {
        containerStyle,
        spinner,
        fullPage,
        textStyle
      } = this.props;
      let localSpinner = spinner;
      if(! spinner && globalSpinner){
        localSpinner = globalSpinner;
      }
      const firstComponent = components[0];
      if(! firstComponent) return null;
      if(firstComponent.id === this.state.id){
        console.log("loader:"+this.state.id);
        const mergedContainerStyle = {
          ...styles.container,
          ...containerStyle,
          position:fullPage?"fixed":"absolute",
          //position:"fixed",
        };
        return (
          <div style={mergedContainerStyle}>
            {localSpinner}
            <span style={{ ...styles.text, ...textStyle }}>
            {_.map(_.uniqBy(components,'text'),(obj,index)=>(
              <p key={index}>{obj.text}</p>
            ))}
            </span>
          </div>
        );
      }else{
        return null;
      }
    }
}

const LoadingOverlay = ({ children,spinner, ...rest }) => {
  globalSpinner = spinner;
  return (
    <div {...rest} style={{ ...rest.style, position: "absolute" }}>
      {children}
    </div>
  );
}

export { LoadingOverlay, Loader };



// WEBPACK FOOTER //
// ./src/components/Loader.js